import { useState, useEffect } from 'react';
import { X } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const PromoPopup = () => {
  const [popup, setPopup] = useState(null);
  const [isVisible, setIsVisible] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchPopup = async () => {
      try {
        const response = await axios.get(`${BACKEND_URL}/api/popup`);
        if (response.data && response.data.image) {
          setPopup(response.data);
          // Verificar se já foi fechado nesta sessão
          const closedPopup = sessionStorage.getItem('popup_closed');
          if (!closedPopup) {
            setTimeout(() => setIsVisible(true), 2000); // Mostrar após 2s
          }
        }
      } catch (error) {
        console.log('No popup available');
      }
    };
    fetchPopup();
  }, []);

  const handleClose = () => {
    setIsVisible(false);
    sessionStorage.setItem('popup_closed', 'true');
  };

  const handleImageClick = () => {
    if (popup?.button_link) {
      if (popup.button_link.startsWith('http')) {
        window.location.href = popup.button_link;
      } else {
        navigate(popup.button_link);
      }
    }
    handleClose();
  };

  if (!popup || !isVisible || !popup.image) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/70 animate-in fade-in duration-300">
      <div className="relative max-w-lg w-full animate-in zoom-in-95 duration-300">
        {/* Close Button */}
        <button 
          onClick={handleClose}
          className="absolute -top-3 -right-3 z-10 bg-white hover:bg-gray-100 p-2 rounded-full shadow-xl transition-all hover:scale-110"
          data-testid="popup-close-btn"
        >
          <X size={24} className="text-gray-700" />
        </button>

        {/* Image Only - Clickable */}
        <div 
          className="w-full overflow-hidden rounded-2xl shadow-2xl cursor-pointer hover:opacity-95 transition-opacity"
          onClick={handleImageClick}
        >
          <img 
            src={popup.image} 
            alt="Promoção"
            className="w-full h-auto object-contain"
          />
        </div>
      </div>
    </div>
  );
};
